import styled from "@emotion/styled";
import { RequiredThemeKeys } from "../../../../util/theme";
import { selectV2Theme } from "../selectV2Theme";

interface ActionsProps {
    themeMode: RequiredThemeKeys;
    // If true, this container should not take up any space.
    isReadonly?: boolean;
}

export const Actions = styled("div")<ActionsProps>`
    display: inline-flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: ${({ themeMode }) => selectV2Theme.actionButtons.gap(themeMode)};

    // For use in the SelectBasic component, we'll set this property.
    align-self: start;

    > button:last-child {
        margin-left: -1px;
    }

    ${({ isReadonly, themeMode }) =>
        isReadonly
            ? ``
            : `
                margin: ${selectV2Theme.actionButtons.margin.top(themeMode)} ${selectV2Theme.actionButtons.margin.top(
                  themeMode
              )} auto 0;
            `}
`;
